import { useSuspenseQuery } from '@tanstack/react-query';
import { likeGoodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

/**
 * 찜한 상품 카테고리 필터 옵션.
 * iOS `LikedProductRouter.categories` 와 동일.
 */
export const useLikedGoodsCategories = () => {
  return useSuspenseQuery({
    queryKey: queryKey.likedGoodsCategories(),
    queryFn: likeGoodsService.getLikedGoodsCategories,
  });
};
